import { render, staticRenderFns } from "./study-header.vue?vue&type=template&id=1b3cdbd6&scoped=true&"
import script from "./study-header.vue?vue&type=script&lang=ts&"
export * from "./study-header.vue?vue&type=script&lang=ts&"
import style0 from "./study-header.vue?vue&type=style&index=0&id=1b3cdbd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3cdbd6",
  null
  
)

export default component.exports